export const getBusinessVoicesUrl = (workspaceId?: string, agentId?: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/voices`;

export const getAgencyVoicesUrl = () => '/agency/voices';

export const getAgencyVoiceCreationUrl = (workspaceId?: string, agentId?: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/voices`;
